export const environment = {
    pageName: 'LAX CMS',
    appFlavor: 'lax',
    production: true,
    appEnv: 'prod',
    googleMapsKey: 'AIzaSyDoHTVe4h8oAu94KvU0qxBmPX7dhWXSKlU',
    apiConfig: {
        projectEndpoint: 'https://lax-api.itxi.aero',
        apiKey: 'auJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9',
    },
    firebase: {
        apiKey: 'AIzaSyDTaCSIOuTWYlVYz-m6TJCCy3GXKjVYqhc',
        authDomain: 'sita-pax-assist.firebaseapp.com',
        databaseURL: 'https://sita-pax-assist.firebaseio.com',
        projectId: 'sita-pax-assist',
        storageBucket: 'sita-pax-assist.appspot.com',
        messagingSenderId: '261861345247',
        appId: '1:261861345247:web:e9e284b65f5c047f',
    },
    googleAnalyticsTrackId: 'UA-107236709-2',
    rolesWithLoginAccess: [
        { role: 'admin', route: 'dashboard/content/users', node: 'users' },
        {
            role: 'editor',
            route: 'dashboard/content/attractions',
            node: 'attractions',
        },
    ],
    sessionTokenCheckInterval: 300000,
    getAllFlightsListInterval: 0,
    sessionTokenExtension: true,
    defaultRoute: 'dashboard/content/attractions',
    enableRandomBackground: true,
    isGoogleAnalyticEnabled: true,
    airportCoordinates: {
        latitude: 33.945,
        longitude: -118.4,
        ISO3166_1_Alpha_2: 'US',
    },
    videoCategories: [
        { key: 'What’s New' },
        { key: 'Around LAX' },
        { key: 'Getting Around' },
        { key: 'LA Tourism' },
        { key: 'Social Responsibility' },
    ],
    userTableLanguages: [
        { key: 'enes', label: 'LANGUAGES.ALL_LANGUAGES' },
        { key: 'en', label: 'LANGUAGES.ENGLISH_ONLY' },
        { key: 'es', label: 'LANGUAGES.SPANISH_ONLY' },
    ],
    userTablesRole: [
        { key: 'agent', label: 'ROLES.AGENT' },
        { key: 'editor', label: 'ROLES.EDITOR' },
        { key: 'admin', label: 'ROLES.ADMIN' },
    ],
    formLanguages: [
        { key: 'en', title: 'LANGUAGES.ENGLISH' },
        { key: 'es', title: 'LANGUAGES.ESPANOL' },
    ],
    microsoftSSOClientId: '',
    googleSSOClientId: '',
    signInOptions: ['password'],
    appCategories: [],
    payment_method: [],
    payment_status: [],
    orientationArray: [],
    containerType: [],
    contentType: [],
    contentItems: [],
    equipmentType: [],
    departureTime: [],
    sectors: [],
    cartItems: [],
    tags: [],
};
